import React from "react";
import { Constants } from "../libs/Constants";
import { getList } from "../libs/dbFunctions";

const emptyPlan = null;

const PlanContext = React.createContext(emptyPlan);
export const usePlan = () => React.useContext(PlanContext);

export const PlanProvider = ({ children }) => {
  const [plan, setPlan] = React.useState(emptyPlan);
  const [plans, setPlans] = React.useState({});
  const loadPlan = async (companyId) => {
    if (plans && companyId in plans) {
      return plans[companyId];
    }
    let planDetail = await getList(Constants.dbTypes.PLAN_DETAILS,
      {
        id: companyId
      });
    if (planDetail && planDetail.length > 0) {
      const modifiedPlan = {
        ...planDetail[0],
        purchasePeriod: Number(planDetail[0].purchasePeriod),
      };
      setPlan(modifiedPlan);
      setPlans({ ...plans, companyId: modifiedPlan });
    }
  };
  return (
    <PlanContext.Provider value={{ plan, loadPlan }}>
      {children}
    </PlanContext.Provider>
  );
};
